module.exports = __webpack_public_path__ + "img/gys_7@2x.89d53db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_7@2x.png
// module id = VKR8
// module chunks = 0